var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.269,13.488l3.457-3.448c.239-.172.492-.01.495.268v11.716c-.008.251-.193.451-.442.477H5.221c-.249-.026-.433-.226-.442-.477v-13.293c0-.251.175-.462.425-.493h3.189c.174-.016.441.224.441.39v4.428l2.972-2.963c.134-.109.269-.176.43-.067.07.048.133.167.133.248v3.163l3.405-3.396c.138-.099.317-.1.424.043.016.021.069.122.069.139v3.267ZM6.599,16.763v2.582h2.911v-2.582h-2.911ZM13.947,16.763h-2.894v2.582h2.894v-2.582ZM18.401,16.763h-2.911v2.582h2.911v-2.582Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.096,5.709c-.116.678-.708,1.164-1.388,1.203-.829,1.482-2.757-.115-1.46-1.215-.146-.768.397-1.525,1.158-1.669.074-1.423,1.881-2.075,2.824-.972.872,1.02.196,2.601-1.134,2.653Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/Manufacturing.2e4b1848e641146947b6ad17b89c9cad.svg";
export { ForwardRef as ReactComponent };